
/*
 * Add a frame for the ad content.
* */
export function buildFrame(data, rootElement) {
    rootElement.innerHTML = ''; // Clear JSON content

    const adWrapper = document.createElement('div');
    adWrapper.classList.add('lokl-ad-wrapper');

    // the actual ad content
    const adContainer = document.createElement('div');
    adContainer.classList.add('lokl-ad-container');

    if(data.intro) {
        const introText = document.createElement('p');
        introText.innerHTML = data.intro;
        introText.classList.add('lokl-ad-intro');
        rootElement.appendChild(introText);
    }

    adWrapper.appendChild(adContainer);
    rootElement.appendChild(adWrapper);

    if(data.description) {
        const descriptionText = document.createElement('p');
        descriptionText.innerHTML = data.description;
        descriptionText.classList.add('lokl-ad-description');
        rootElement.appendChild(descriptionText);
    }

    if(data.badge) {
        const badge = document.createElement('div');
        badge.innerHTML = data.badge;
        badge.classList.add('lokl-ad-badge');
        rootElement.appendChild(badge);
    }

    rootElement.classList.add('lokl-ad-container-wrapper');
}